<template>
    <div class="countdown-header">
        <template v-if="showBackButton">
            <button
                @click="backToList"
                class="countdown-header__back-button btn btn-icon"
                :class="{ invisible: !backButtonVisible }"
                :title="$t('ProductSelect.bidding.chooseDuration')"
            >
                <IconSvg filepath="back.svg" class="countdown-header__back-button-icon" />
                <span>{{ $t('ProductSelect.bidding.chooseDuration') }}</span>
            </button>
        </template>

        <section class="text-center">
            <CountdownTimer
                :available-until="availableUntil"
                @expired="isExpired = true"
                show-heading
                class="countdown-header__timer"
                :class="{ 'countdown-header__timer--expired': isExpired }"
            />
        </section>
    </div>
</template>

<script>
import CountdownTimer from '@/components/product/countdown/CountdownTimer.vue';

export default {
    name: 'ProductSelectCountdownHeader',
    components: { CountdownTimer },
    data() {
        return {
            isExpired: false
        };
    },
    props: {
        availableUntil: {
            type: String,
            required: true
        },
        backButtonVisible: Boolean // for visibility css rule, since it needs to preserve space for CLS prevention
    },

    computed: {
        showBackButton() {
            const backButtonPropExplicitlySet = this.$options.propsData.backButtonVisible !== undefined;
            return backButtonPropExplicitlySet;
        }
    },

    methods: {
        backToList() {
            this.$emit('back');
        }
    },

    watch: {
        isExpired: {
            handler(expired) {
                expired && this.$emit('expired');
            },
            immediate: true
        }
    }
};
</script>

<style scoped lang="scss">
.countdown-header {
    width: 100%;

    &__back-button {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin-bottom: 1rem;
        margin-right: 1rem;
        color: currentColor;
        line-height: 1em;

        &-icon {
            font-size: 1.2em;
        }

        &:hover {
            color: currentColor;
        }
    }

    &__timer {
        margin-bottom: 1rem;

        &--expired {
            margin-top: 1rem; // to prevent big jumps of below content as timer gets smaller
        }
    }
}
</style>
